var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppRouter } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { DialogService, WaitingMode, WaitingService } from '@gh/core-ui';
import { beforeCurrentDate, currentDate, getMonthLogicalName, isDatesEquals, isDateWeekend, replaceUrlSegment, } from '@gh/core-util';
import { skip$ } from '@gh/rx/operators';
import { SupplierUserContext } from '@gh/supplier-shared';
import { chunk, clone } from 'lodash';
import { getCalendar, SupplierCalendarBusinessService } from '../../resources';
import { supplierOrderInfoDialogRoute } from '../supplier-order-info-dialog';
import * as i0 from "@angular/core";
import * as i1 from "@gh/supplier-shared";
import * as i2 from "@gh/common-shared";
import * as i3 from "@gh/core-ui";
import * as i4 from "@gh/core-mls";
import * as i5 from "../../resources";
import * as i6 from "@angular/router";
import * as i7 from "../../../common-external-shared/components/ext-page/ext-page.component";
import * as i8 from "@angular/flex-layout/flex";
import * as i9 from "@angular/flex-layout/extended";
import * as i10 from "@angular/material/form-field";
import * as i11 from "@angular/material/select";
import * as i12 from "@angular/common";
import * as i13 from "@angular/material/core";
import * as i14 from "../../../core-mls/translation/translate.pipe";
function SupplierCalendarComponent_mat_option_26_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var office_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(office_r2.name);
} }
function SupplierCalendarComponent_mat_option_26_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_no_active_offices"));
} }
function SupplierCalendarComponent_mat_option_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 18);
    i0.ɵɵtemplate(1, SupplierCalendarComponent_mat_option_26_ng_container_1_Template, 2, 1, "ng-container", 19);
    i0.ɵɵtemplate(2, SupplierCalendarComponent_mat_option_26_ng_container_2_Template, 3, 3, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var office_r2 = ctx.$implicit;
    var ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", office_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.offices.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.offices.length);
} }
function SupplierCalendarComponent_div_78_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", order_r11.purchaseOrder, " ");
} }
function SupplierCalendarComponent_div_78_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵlistener("click", function SupplierCalendarComponent_div_78_div_1_div_5_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r14); var item_r8 = i0.ɵɵnextContext().$implicit; var ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.onOpenOrderInfo(item_r8); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r8 = i0.ɵɵnextContext().$implicit;
    var ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r10.getOrdersByDate(item_r8).length);
} }
var _c0 = function (a0, a1, a2) { return { "weekend": a0, "before": a1, "now": a2 }; };
function SupplierCalendarComponent_div_78_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵtemplate(4, SupplierCalendarComponent_div_78_div_1_div_4_Template, 2, 1, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SupplierCalendarComponent_div_78_div_1_div_5_Template, 3, 1, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r8 = ctx.$implicit;
    var ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c0, ctx_r7.isWeekEnd(item_r8), ctx_r7.isDateBefore(item_r8), ctx_r7.isNow(item_r8)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r8.getDate(), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r7.getOrdersByDate(item_r8));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.getOrdersByDate(item_r8).length);
} }
function SupplierCalendarComponent_div_78_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, SupplierCalendarComponent_div_78_div_1_Template, 6, 8, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var row_r6 = ctx.$implicit;
    var ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-height", 100 / ctx_r1.currentDates.length, "%");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", row_r6);
} }
var EMPTY_OFFICE = {};
var SupplierCalendarComponent = /** @class */ (function () {
    function SupplierCalendarComponent(userContext, appRouter, dialogs, translations, waitings, businessService, route) {
        this.userContext = userContext;
        this.appRouter = appRouter;
        this.dialogs = dialogs;
        this.translations = translations;
        this.waitings = waitings;
        this.businessService = businessService;
        this.route = route;
        this.calendarItems = [];
        this.currentDate = currentDate();
        this.currentDates = [];
    }
    Object.defineProperty(SupplierCalendarComponent.prototype, "currentMonthName", {
        get: function () {
            var monthName = getMonthLogicalName(this.currentDate.getMonth());
            return this.translations.get("lbl_" + monthName);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SupplierCalendarComponent.prototype, "itemHeight", {
        get: function () {
            var _this = this;
            var ordersLimit = 4;
            var ordersHeight = 11;
            var spaceHeight = 40;
            var maxOrderCount = 0;
            this.currentDates
                .forEach(function (row) {
                row.forEach(function (item) {
                    var ordersCount = _this.getOrdersByDate(item).length;
                    maxOrderCount = ordersCount > maxOrderCount ? ordersCount : maxOrderCount;
                });
            });
            return maxOrderCount <= ordersLimit ? 0 : maxOrderCount * ordersHeight + spaceHeight;
        },
        enumerable: true,
        configurable: true
    });
    SupplierCalendarComponent.prototype.ngOnInit = function () {
        this.getOffices();
        this.currentMonth();
        this.subscribeToNavigation();
    };
    SupplierCalendarComponent.prototype.ngOnDestroy = function () {
        this.calendarSubscription$.unsubscribe();
    };
    SupplierCalendarComponent.prototype.isNow = function (date) {
        return isDatesEquals(currentDate(), date);
    };
    SupplierCalendarComponent.prototype.isWeekEnd = function (date) {
        return isDateWeekend(date);
    };
    SupplierCalendarComponent.prototype.isDateBefore = function (date) {
        return beforeCurrentDate(date);
    };
    SupplierCalendarComponent.prototype.getOrdersByDate = function (date) {
        var _this = this;
        return this.calendarItems.filter(function (item) { return _this.dateHasOrder(date, item); });
    };
    SupplierCalendarComponent.prototype.onOpenOrderInfo = function (date) {
        var orders = this.getOrdersByDate(date);
        this.dialogs.openWithInput(supplierOrderInfoDialogRoute, {
            date: date,
            orders: orders,
        });
    };
    SupplierCalendarComponent.prototype.currentMonth = function () {
        this.currentDate = currentDate();
        this.getCalendarItems();
    };
    SupplierCalendarComponent.prototype.nextMonth = function (next) {
        this.currentDate = new Date(this.currentDate.getFullYear(), next ? this.currentDate.getMonth() + 1 : this.currentDate.getMonth() - 1, this.currentDate.getDate());
        this.getCalendarItems();
    };
    SupplierCalendarComponent.prototype.onCurrentOfficeChange = function (office) {
        this.currentOffice = office;
        this.redirectToOffice();
    };
    SupplierCalendarComponent.prototype.redirectToOffice = function () {
        this.appRouter
            .navigateByUrl(replaceUrlSegment(this.appRouter.url, 1, this.currentOffice.id || 'all'));
    };
    SupplierCalendarComponent.prototype.dateHasOrder = function (item, order) {
        return isDatesEquals(item, order.deliveryDate);
    };
    SupplierCalendarComponent.prototype.getCalendar = function () {
        var datesPerRow = 7;
        this.currentDates = chunk(getCalendar(this.currentDate), datesPerRow);
    };
    SupplierCalendarComponent.prototype.getCalendarItems = function () {
        var _this = this;
        this.getCalendar();
        this.calendarSubscription$ = this.businessService
            .getCalendarItems(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentOffice.id).pipe(this.waitings.operator(WaitingMode.Background))
            .subscribe(function (items) { return _this.calendarItems = items; });
    };
    SupplierCalendarComponent.prototype.getEmptyOffice = function () {
        return __assign(__assign({}, EMPTY_OFFICE), { name: this.translations.get('lbl_all') });
    };
    SupplierCalendarComponent.prototype.getOffices = function () {
        var offices = clone(this.userContext.offices);
        this.offices = offices.length ? offices : [EMPTY_OFFICE];
        if (this.offices.length > 1) {
            this.offices.unshift(this.getEmptyOffice());
            this.currentOffice = this.offices[0];
        }
        else {
            this.currentOffice = this.userContext.currentOffice;
        }
    };
    SupplierCalendarComponent.prototype.subscribeToNavigation = function () {
        var _this = this;
        this.route
            .params.pipe(skip$(1))
            .subscribe(function (params) {
            _this.currentOffice = 'all' === params.officeId ? _this.offices[0] : _this.userContext.currentOffice;
            _this.getCalendarItems();
        });
    };
    SupplierCalendarComponent.ɵfac = function SupplierCalendarComponent_Factory(t) { return new (t || SupplierCalendarComponent)(i0.ɵɵdirectiveInject(i1.SupplierUserContext), i0.ɵɵdirectiveInject(i2.AppRouter), i0.ɵɵdirectiveInject(i3.DialogService), i0.ɵɵdirectiveInject(i4.TranslationService), i0.ɵɵdirectiveInject(i3.WaitingService), i0.ɵɵdirectiveInject(i5.SupplierCalendarBusinessService), i0.ɵɵdirectiveInject(i6.ActivatedRoute)); };
    SupplierCalendarComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierCalendarComponent, selectors: [["gh-supplier-calendar"]], decls: 79, vars: 65, consts: [[3, "title"], ["fxLayout", "column", "fxFlex", "1 1 0", 1, "calendar"], ["fxLayout", "row", "fxLayoutAlign", "space-between center", "fxLayout.lt-md", "column-reverse", 1, "calendar-menu"], ["fxLayout", "row", "fxLayoutAlign", "start center", 1, "calendar-menu-nav"], ["href", "javascript:void(0)", 1, "calendar-menu-nav-link", 3, "click"], ["fxFlex", "1 1 0", 1, "calendar-menu-month"], ["fxLayout", "row", "fxLayoutAlign", "start center", "fxShow", "", "fxHide.lt-md", "true", 1, "calendar-menu-office"], [1, "calendar-menu-office-label"], ["fxFlex", "", 1, "m-office-selector"], [1, "ext-main-selector"], ["floatLabel", "always", "ghCompareBy", "id", 3, "placeholder", "value", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["fxLayout", "row", "fxLayoutAlign", "space-around start", 1, "calendar-header"], ["fxFlex", "1 0 auto", 1, "calendar-header-item"], ["fxShow", "", "fxHide.lt-md", "true"], ["fxHide", "", "fxShow.lt-md", "true"], ["fxFlex", "1 1 0", 1, "calendar-body"], ["class", "calendar-row", "fxLayout", "row", 3, "min-height", 4, "ngFor", "ngForOf"], [3, "value"], [4, "ngIf"], ["fxLayout", "row", 1, "calendar-row"], ["class", "calendar-item", "fxLayout", "column", 3, "ngClass", 4, "ngFor", "ngForOf"], ["fxLayout", "column", 1, "calendar-item", 3, "ngClass"], [1, "calendar-item-date"], ["fxFlex", "auto", "fxLayout", "column", "fxLayoutAlign", "end", "fxShow", "", "fxHide.lt-lg", "true", 1, "calendar-item-orders"], ["class", "calendar-item-order", 4, "ngFor", "ngForOf"], ["class", "calendar-item-orders", "fxFlex", "auto", "fxLayout", "column", "fxLayoutAlign", "end", "fxHide", "", "fxShow.lt-lg", "true", 4, "ngIf"], [1, "calendar-item-order"], ["fxFlex", "auto", "fxLayout", "column", "fxLayoutAlign", "end", "fxHide", "", "fxShow.lt-lg", "true", 1, "calendar-item-orders"], [1, "calendar-item-order", 3, "click"]], template: function SupplierCalendarComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "gh-ext-page");
            i0.ɵɵelement(1, "gh-ext-page-title", 0);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "gh-ext-page-content");
            i0.ɵɵelementStart(4, "div", 1);
            i0.ɵɵelementStart(5, "div", 2);
            i0.ɵɵelementStart(6, "div", 3);
            i0.ɵɵelementStart(7, "a", 4);
            i0.ɵɵlistener("click", function SupplierCalendarComponent_Template_a_click_7_listener() { return ctx.nextMonth(false); });
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "a", 4);
            i0.ɵɵlistener("click", function SupplierCalendarComponent_Template_a_click_10_listener() { return ctx.currentMonth(); });
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "a", 4);
            i0.ɵɵlistener("click", function SupplierCalendarComponent_Template_a_click_13_listener() { return ctx.nextMonth(true); });
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "div", 5);
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "div", 6);
            i0.ɵɵelementStart(19, "label", 7);
            i0.ɵɵtext(20);
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "div", 8);
            i0.ɵɵelementStart(23, "mat-form-field", 9);
            i0.ɵɵelementStart(24, "mat-select", 10);
            i0.ɵɵlistener("selectionChange", function SupplierCalendarComponent_Template_mat_select_selectionChange_24_listener($event) { return ctx.onCurrentOfficeChange($event.value); });
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵtemplate(26, SupplierCalendarComponent_mat_option_26_Template, 3, 3, "mat-option", 11);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(27, "div", 12);
            i0.ɵɵelementStart(28, "div", 13);
            i0.ɵɵelementStart(29, "span", 14);
            i0.ɵɵtext(30);
            i0.ɵɵpipe(31, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "span", 15);
            i0.ɵɵtext(33);
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(35, "div", 13);
            i0.ɵɵelementStart(36, "span", 14);
            i0.ɵɵtext(37);
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "span", 15);
            i0.ɵɵtext(40);
            i0.ɵɵpipe(41, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(42, "div", 13);
            i0.ɵɵelementStart(43, "span", 14);
            i0.ɵɵtext(44);
            i0.ɵɵpipe(45, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(46, "span", 15);
            i0.ɵɵtext(47);
            i0.ɵɵpipe(48, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(49, "div", 13);
            i0.ɵɵelementStart(50, "span", 14);
            i0.ɵɵtext(51);
            i0.ɵɵpipe(52, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(53, "span", 15);
            i0.ɵɵtext(54);
            i0.ɵɵpipe(55, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(56, "div", 13);
            i0.ɵɵelementStart(57, "span", 14);
            i0.ɵɵtext(58);
            i0.ɵɵpipe(59, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(60, "span", 15);
            i0.ɵɵtext(61);
            i0.ɵɵpipe(62, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(63, "div", 13);
            i0.ɵɵelementStart(64, "span", 14);
            i0.ɵɵtext(65);
            i0.ɵɵpipe(66, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(67, "span", 15);
            i0.ɵɵtext(68);
            i0.ɵɵpipe(69, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(70, "div", 13);
            i0.ɵɵelementStart(71, "span", 14);
            i0.ɵɵtext(72);
            i0.ɵɵpipe(73, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(74, "span", 15);
            i0.ɵɵtext(75);
            i0.ɵɵpipe(76, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(77, "div", 16);
            i0.ɵɵtemplate(78, SupplierCalendarComponent_div_78_Template, 2, 3, "div", 17);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 25, "lbl_calendar"));
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 27, "lbl_prev"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 29, "lbl_current"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 31, "lbl_next"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.currentMonthName, " ", ctx.currentDate.getFullYear(), "");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 33, "lbl_office"));
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(25, 35, "lbl_office"));
            i0.ɵɵproperty("value", ctx.currentOffice);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.offices);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 37, "lbl_sunday"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(34, 39, "lbl_sunday_short"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 41, "lbl_monday"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(41, 43, "lbl_monday_short"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(45, 45, "lbl_tuesday"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(48, 47, "lbl_tuesday_short"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(52, 49, "lbl_wednesday"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(55, 51, "lbl_wednesday_short"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(59, 53, "lbl_thursday"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(62, 55, "lbl_thursday_short"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(66, 57, "lbl_friday"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(69, 59, "lbl_friday_short"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(73, 61, "lbl_saturday"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(76, 63, "lbl_saturday_short"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.currentDates);
        } }, directives: [i7.ExtPageComponent, i7.ExtPageTitleDirective, i7.ExtPageContentComponent, i8.DefaultLayoutDirective, i8.DefaultFlexDirective, i8.DefaultLayoutAlignDirective, i9.DefaultShowHideDirective, i10.MatFormField, i11.MatSelect, i12.NgForOf, i13.MatOption, i12.NgIf, i12.NgClass, i9.DefaultClassDirective], pipes: [i14.TranslatePipe], styles: ["[_nghost-%COMP%], [_nghost-%COMP%]   *[_ngcontent-%COMP%] {\n  box-sizing: border-box; }\n\n[_nghost-%COMP%]     .mat-form-field-label-wrapper {\n  display: none; }\n\n[_nghost-%COMP%]   .calendar[_ngcontent-%COMP%] {\n  padding: 33px 20px 23px 20px;\n  min-height: 100%; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%]   .calendar[_ngcontent-%COMP%] {\n      padding: 15px 20px; } }\n\n[_nghost-%COMP%]   .calendar-menu[_ngcontent-%COMP%] {\n  align-items: center;\n  margin-bottom: 42px; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%]   .calendar-menu[_ngcontent-%COMP%] {\n      margin-bottom: 30px; } }\n\n[_nghost-%COMP%]   .calendar-menu-nav[_ngcontent-%COMP%] {\n  height: 26px;\n  border: 1px solid #b7022f;\n  border-radius: 13px; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%]   .calendar-menu-nav[_ngcontent-%COMP%] {\n      height: 40px;\n      border-radius: 20px; } }\n\n[_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%] {\n  display: inline-block;\n  position: relative;\n  color: #b7022f;\n  text-decoration: none;\n  font-size: 16px;\n  padding: 0 7px; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%] {\n      padding: 11px 30px; } }\n  [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:first-child {\n    padding-left: 12px; }\n    @media (max-width: 959px) {\n      [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:first-child {\n        padding-left: 30px; } }\n  [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:last-child {\n    padding-right: 12px; }\n    @media (max-width: 959px) {\n      [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:last-child {\n        padding-right: 30px; } }\n  [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:nth-child(2n):before, [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:nth-child(2n):after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: -4px;\n    height: 26px;\n    width: 1px;\n    background: #b7022f; }\n    @media (max-width: 959px) {\n      [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:nth-child(2n):before, [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:nth-child(2n):after {\n        top: 0;\n        height: 40px; } }\n  [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:nth-child(2n):before {\n    left: 0; }\n  [_nghost-%COMP%]   .calendar-menu-nav-link[_ngcontent-%COMP%]:nth-child(2n):after {\n    right: 0; }\n\n[_nghost-%COMP%]   .calendar-menu-month[_ngcontent-%COMP%] {\n  font-size: 40px;\n  text-align: center; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%]   .calendar-menu-month[_ngcontent-%COMP%] {\n      font-size: 24px;\n      margin-bottom: 15px; } }\n\n[_nghost-%COMP%]   .calendar-menu-office-label[_ngcontent-%COMP%] {\n  color: rgba(112, 112, 112, 0.87);\n  font-size: 18px;\n  font-weight: bold;\n  margin-right: 10px; }\n\n[_nghost-%COMP%]   .calendar-header-item[_ngcontent-%COMP%] {\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center; }\n\n[_nghost-%COMP%]   .calendar-item[_ngcontent-%COMP%] {\n  flex: 1 1 0;\n  margin: 5px;\n  border: 1px solid rgba(183, 2, 47, 0.2);\n  padding: 5px 10px;\n  position: relative; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%]   .calendar-item[_ngcontent-%COMP%] {\n      margin: 5px 2px;\n      padding: 8px; } }\n\n[_nghost-%COMP%]   .calendar-item-date[_ngcontent-%COMP%] {\n  font-size: 20px;\n  font-weight: bold;\n  text-align: right; }\n  @media (max-width: 959px) {\n    [_nghost-%COMP%]   .calendar-item-date[_ngcontent-%COMP%] {\n      font-size: 14px;\n      font-weight: normal;\n      text-align: center; } }\n\n[_nghost-%COMP%]   .calendar-item-orders[_ngcontent-%COMP%] {\n  bottom: 3px;\n  left: 0;\n  width: 100%;\n  padding: 0 2px; }\n  @media (max-width: 1279px) {\n    [_nghost-%COMP%]   .calendar-item-orders[_ngcontent-%COMP%] {\n      bottom: 2px; } }\n\n[_nghost-%COMP%]   .calendar-item-order[_ngcontent-%COMP%] {\n  background-color: rgba(112, 112, 112, 0.87);\n  border-radius: 13px;\n  font-size: 12px;\n  color: #fff;\n  text-align: center;\n  margin-bottom: 1px; }\n  @media (min-width: 1280px) {\n    [_nghost-%COMP%]   .calendar-item-order[_ngcontent-%COMP%] {\n      padding: 0 12px; } }\n  @media (max-width: 1279px) {\n    [_nghost-%COMP%]   .calendar-item-order[_ngcontent-%COMP%] {\n      cursor: pointer;\n      width: 20px;\n      height: 20px;\n      border-radius: 100%;\n      background-color: #707070;\n      color: #fff;\n      margin: 0 auto;\n      padding: 2px 0 0; } }\n\n[_nghost-%COMP%]   .weekend[_ngcontent-%COMP%] {\n  background-color: rgba(112, 112, 112, 0.1);\n  color: #b7022f; }\n\n[_nghost-%COMP%]   .before[_ngcontent-%COMP%] {\n  color: rgba(183, 2, 47, 0.2); }\n\n[_nghost-%COMP%]   .now[_ngcontent-%COMP%] {\n  color: #000;\n  background-color: rgba(183, 2, 47, 0.2); }"] });
    return SupplierCalendarComponent;
}());
export { SupplierCalendarComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'gh-supplier-calendar',
                templateUrl: 'supplier-calendar.component.html',
                styleUrls: ['./supplier-calendar.component.scss'],
            }]
    }], function () { return [{ type: i1.SupplierUserContext }, { type: i2.AppRouter }, { type: i3.DialogService }, { type: i4.TranslationService }, { type: i3.WaitingService }, { type: i5.SupplierCalendarBusinessService }, { type: i6.ActivatedRoute }]; }, null); })();
